import { useQuery } from "@apollo/client";
import ObjectHeading, { type MetaData } from "@/components/ObjectHeading";
import { ProfileSkeleton } from "@/components/Skeleton";
import {
  FACILITY_DETAILS_HEADER_QUERY,
  type FacilityDetailsHeaderQueryResponse
} from "@/pages/facilities/[facilityId]/queries";

export type FacilityObjectHeadingWrapperProps = {
  facilityId: string;
  variant?: "complete" | "condensed" | "landing-page";
  avatarSize?: "small" | "medium" | "large" | "xlarge";
  showMinimalMetadata?: boolean;
};

export const FacilityObjectHeadingWrapper = ({
  facilityId,
  variant = "condensed",
  avatarSize = "medium",
  showMinimalMetadata = true
}: FacilityObjectHeadingWrapperProps) => {
  const { data, loading, error } = useQuery<FacilityDetailsHeaderQueryResponse>(FACILITY_DETAILS_HEADER_QUERY, {
    variables: { facilityId },
    errorPolicy: "all"
  });

  if (loading) return <ProfileSkeleton />;
  if (error || !data?.facility) return null;

  const { facility } = data;

  const metaData: MetaData = showMinimalMetadata
    ? facility.legacyId
      ? [{ text: facility.legacyId, label: "Facility ID", copyable: true }]
      : []
    : [
        ...(facility.section ? [{ text: facility.section.name, label: "Section" }] : []),
        ...(facility.legacyId ? [{ text: facility.legacyId, label: "Facility ID", copyable: true }] : [])
      ];

  return (
    <ObjectHeading
      title={facility.name}
      iconName="store"
      metaData={metaData}
      isDetailsView
      variant={variant}
      avatarSize={avatarSize}
    />
  );
};
